module.exports = __webpack_public_path__ + "media/images/normal-logo-symbol@2x-a6d5b9f24e34b8fdbc196b3b4306d8b6.png";